import React from 'react';

// I disegni dei tre passi dell'installazione: fatti da noi, in stile app.
//
// Perché non le schermate vere di Apple: invecchiano a ogni versione di iOS (il menu Condividi è cambiato tre
// volte in tre anni), pesano, e le immagini dell'interfaccia di Apple non si ridistribuiscono. Un disegno
// essenziale dice la stessa cosa in un colpo d'occhio, si legge anche su uno schermo piccolo, e quando iOS
// cambia resta vero: l'icona Condividi è un quadrato con la freccia in su, e lo sarà ancora.
//
// Ogni disegno è un SVG di 92×92, senza testo dentro (le parole stanno accanto, tradotte).

const Cornice = ({ titolo, children }) => (
  <svg className="dis" width="92" height="92" viewBox="0 0 92 92" role="img" aria-label={titolo}>
    <title>{titolo}</title>
    {children}
  </svg>
);

// ---------------------------------------------------------------- iPhone

// 1. La barra di Safari in basso, con l'icona Condividi accesa e la freccia che la indica
export const DisegnoCondividi = ({ titolo }) => (
  <Cornice titolo={titolo}>
    <rect className="corpo" x="14" y="6" width="64" height="80" rx="10" />
    {/* la pagina */}
    <path className="tratto" d="M24 22h32M24 30h44M24 38h38" />
    {/* la barra degli strumenti in basso */}
    <path className="tratto" d="M14 62h64" />
    <g className="spento">
      <circle cx="27" cy="74" r="2.2" /><circle cx="38" cy="74" r="2.2" />
      <circle cx="60" cy="74" r="2.2" /><circle cx="70" cy="74" r="2.2" />
    </g>
    {/* l'icona Condividi: il quadrato con la freccia che esce in alto */}
    <g className="acceso">
      <path d="M44 72.5v-8" />
      <path d="M41 67.5l3-3 3 3" />
      <path d="M39.5 71v6.5h9V71" />
    </g>
    {/* la freccia che indica, in movimento */}
    <g className="freccia">
      <path className="acceso" d="M44 54v5" />
      <path className="pieno" d="M44 62l-3-4h6z" />
    </g>
  </Cornice>
);

// 2. Il pannello Condividi aperto, con la riga «Aggiungi alla schermata Home» accesa
export const DisegnoAggiungi = ({ titolo }) => (
  <Cornice titolo={titolo}>
    <rect className="corpo" x="14" y="6" width="64" height="80" rx="10" />
    {/* il pannello che sale dal basso */}
    <path className="corpo" d="M14 40h64v46a10 10 0 0 1-10 10H24a10 10 0 0 1-10-10z" />
    <path className="tratto" d="M39 46h14" />
    {/* le righe del menu */}
    <g className="spento">
      <rect x="22" y="55" width="8" height="8" rx="2" /><rect x="34" y="57" width="26" height="4" rx="2" />
      <rect x="22" y="79" width="8" height="8" rx="2" /><rect x="34" y="81" width="22" height="4" rx="2" />
    </g>
    {/* la riga giusta, accesa: il quadrato con il + */}
    <rect className="riquadro" x="18" y="65" width="56" height="12" rx="5" />
    <g className="acceso">
      <rect x="22.5" y="67.5" width="7" height="7" rx="1.5" />
      <path d="M26 69.2v3.6M24.2 71h3.6" />
    </g>
    <rect className="pieno" x="34" y="69" width="30" height="4" rx="2" />
  </Cornice>
);

// 3. La conferma: il bottone «Aggiungi» in alto a destra
export const DisegnoConferma = ({ titolo }) => (
  <Cornice titolo={titolo}>
    <rect className="corpo" x="14" y="6" width="64" height="80" rx="10" />
    {/* la barra in alto della finestrella, con Annulla a sinistra e Aggiungi a destra */}
    <path className="tratto" d="M14 28h64" />
    <rect className="spento" x="21" y="15" width="14" height="4" rx="2" />
    <rect className="riquadro" x="52" y="11" width="22" height="12" rx="6" />
    {/* l'icona dell'app e il suo nome, come li mostra iOS prima di aggiungere */}
    <rect className="riquadro" x="28" y="40" width="20" height="20" rx="6" />
    <path className="acceso" d="M34 54v-6l4-3 4 3v6" />
    <rect className="spento" x="54" y="44" width="16" height="4" rx="2" />
    <rect className="spento" x="54" y="52" width="10" height="4" rx="2" />
    <path className="tratto" d="M22 70h48" />
    {/* la freccia che indica il bottone in alto a destra */}
    <g className="freccia">
      <path className="acceso" d="M63 33v-4" />
      <path className="pieno" d="M63 26l3 4h-6z" />
    </g>
  </Cornice>
);

// ---------------------------------------------------------------- Android

// 1. Il menu del browser: i tre puntini in alto a destra
export const DisegnoMenu = ({ titolo }) => (
  <Cornice titolo={titolo}>
    <rect className="corpo" x="14" y="6" width="64" height="80" rx="10" />
    <path className="tratto" d="M14 26h64" />
    <rect className="spento" x="22" y="14" width="28" height="5" rx="2.5" />
    {/* i tre puntini, accesi */}
    <g className="pieno">
      <circle cx="67" cy="12" r="2.2" /><circle cx="67" cy="17" r="2.2" /><circle cx="67" cy="22" r="2.2" />
    </g>
    <path className="tratto" d="M24 40h32M24 50h44M24 60h38M24 70h28" />
    <g className="freccia">
      <path className="acceso" d="M67 36v-5" />
      <path className="pieno" d="M67 28l3 4h-6z" />
    </g>
  </Cornice>
);

// 2. La voce «Installa app» nel menu
export const DisegnoInstallaApp = ({ titolo }) => (
  <Cornice titolo={titolo}>
    <rect className="corpo" x="14" y="6" width="64" height="80" rx="10" />
    {/* il menu che scende dall'angolo */}
    <rect className="corpo" x="34" y="12" width="44" height="60" rx="8" />
    <g className="spento">
      <rect x="40" y="20" width="24" height="4" rx="2" />
      <rect x="40" y="31" width="30" height="4" rx="2" />
      <rect x="40" y="57" width="26" height="4" rx="2" />
    </g>
    {/* la voce giusta, accesa: il telefono con la freccia che entra */}
    <rect className="riquadro" x="36" y="39" width="40" height="13" rx="5" />
    <g className="acceso">
      <rect x="39.5" y="41.5" width="7" height="9" rx="1.5" />
      <path d="M43 43.6v4M41.4 46l1.6 1.6 1.6-1.6" />
    </g>
    <rect className="pieno" x="50" y="43.5" width="22" height="4" rx="2" />
  </Cornice>
);

// 3. La finestrella di conferma con il bottone «Installa»
export const DisegnoConfermaAndroid = ({ titolo }) => (
  <Cornice titolo={titolo}>
    <rect className="corpo" x="14" y="6" width="64" height="80" rx="10" />
    {/* la finestrella al centro */}
    <rect className="corpo" x="20" y="28" width="52" height="42" rx="8" />
    <rect className="riquadro" x="27" y="35" width="14" height="14" rx="4" />
    <path className="acceso" d="M31 45v-4l3-2.2 3 2.2v4" />
    <rect className="spento" x="46" y="37" width="18" height="4" rx="2" />
    <rect className="spento" x="46" y="44" width="12" height="4" rx="2" />
    <rect className="spento" x="27" y="58" width="14" height="5" rx="2.5" />
    {/* il bottone «Installa», acceso */}
    <rect className="riquadro" x="48" y="55" width="20" height="11" rx="5.5" />
    <g className="freccia">
      <path className="acceso" d="M58 78v-5" />
      <path className="pieno" d="M58 70l3 4h-6z" />
    </g>
  </Cornice>
);

// 4. Solo per l'avviso «apritela in Safari»: la bussola di Safari, disegnata semplice
export const DisegnoSafari = ({ titolo }) => (
  <Cornice titolo={titolo}>
    <circle className="corpo" cx="46" cy="46" r="32" />
    <circle className="tratto" cx="46" cy="46" r="24" />
    <path className="pieno" d="M58 34L42 42l-8 16 16-8z" />
    <g className="tratto"><path d="M46 12v5M46 75v5M12 46h5M75 46h5" /></g>
  </Cornice>
);
